import { Skeleton } from 'primitives/skeleton'

export const SkeletonFooter = () => (
  <div className="flex w-full flex-col-reverse items-center justify-between gap-4 overflow-auto px-2 py-1 sm:flex-row sm:gap-8">
    <Skeleton className="h-8 w-40" />
    <div className="flex flex-col-reverse items-center gap-4 sm:flex-row sm:gap-6 lg:gap-8">
      <div className="flex items-center space-x-2">
        <Skeleton className="h-8 w-24" />
        <Skeleton className="h-8 w-[4.5rem]" />
      </div>
      <div className="flex items-center justify-center font-jetbrains text-xs-400 tabular-nums normal-case tracking-normal text-secondary">
        <Skeleton className="h-8 w-20" />
      </div>
      <div className="flex items-center space-x-2">
        <Skeleton className="hidden size-8 lg:block" />
        <Skeleton className="size-8" />
        <Skeleton className="size-8" />
        <Skeleton className="hidden size-8 lg:block" />
      </div>
    </div>
  </div>
)
